import React, { useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Modal from "../modals/Modal";
import InputSelectTypeOfEntry from "./components/inputSelectTypeOfEntry";
import Purchase from "./Purchase";
import InitInventory from "./InitInventory";

// styles
import useStyles from "./styles";

export default function ProductEntry() {
  const classes = useStyles();

  const [entryType, setEntryType] = useState({ text: '', valid: null });

  const [showModal, setShowModal] = useState(false);
  const [keySelect, setKeySelect] = useState(0);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  return (
    <>
      {showModal ? (
        <Modal
          isOpen={showModal}
          closeModal={closeModalLogin}
        />
      ) : (
        <></>
      )}

      <div className={classes.divTitle}>
        <PageTitle title="Entrada de productos" />
      </div>

      <div>
        <label className={classes.titleStyle}>Selecciona una opción</label>
        <div style={{ width: "300px" }}>
          <InputSelectTypeOfEntry
            text={entryType}
            setValue={setEntryType}
            keySelect={keySelect}
          />
        </div>
        <br /> <br />
      </div>

      {entryType.text == "" ? (
        <></>
      ) : (
        <>
          {entryType.text == "initialInventory" ? (
            <>
              <InitInventory />
            </>
          ) : (
            <>
              <Purchase />
            </>
          )}
        </>
      )}
    </>
  );
}
